// public int pet_no { get; set; }
//     public string rabie_tag_no { get; set; }
//     public int rabie_vacc_no { get; set; }
//     public DateTime rabie_vacc_date { get; set; }
//     public int rabie_doctor { get; set; }
//     public int rabie_clinic { get; set; }
//     public int rabie_year { get; set; }
//     public string? clinic_abbrev { get; set; }
//     public string? pet_name { get; set; }

export class PetRabieModel {
    pet_no: number
    rabie_tag_no: string
    rabie_vacc_no: number
    rabie_vacc_date: Date
    rabie_doctor: number
    rabie_clinic: number
    rabie_year: number
    clinic_abbrev?: string
    pet_name?: string

    constructor(
        pet_no: number,
        rabie_tag_no: string,
        rabie_vacc_no: number,
        rabie_vacc_date: Date,
        rabie_doctor: number,
        rabie_clinic: number,
        rabie_year: number,
        clinic_abbrev?: string,
        pet_name?: string
    ) {
        this.pet_no = pet_no
        this.rabie_tag_no = rabie_tag_no
        this.rabie_vacc_no = rabie_vacc_no
        this.rabie_vacc_date = rabie_vacc_date
        this.rabie_doctor = rabie_doctor
        this.rabie_clinic = rabie_clinic
        this.rabie_year = rabie_year
        this.clinic_abbrev = clinic_abbrev
        this.pet_name = pet_name
    }
}